<template>
  <div  class="check">
    <div class="warning">
      <p>В Вашем браузере не установлен КриптоПро ЭЦП Browser plug-in</p>
    </div>
    <div>
      <p>
        КриптоПро ЭЦП Browser plug-in предназначен для создания и проверки
        электронной подписи (ЭП) на веб-страницах и поддерживает работу с
        широким набором алгоритмов, как встроенных в операционную систему, так и
        доустановленных дополнительно.
      </p>
    </div>
    <div>
      <p>Для работы плагина выполните следующие шаги:</p>
    </div>
    <div class="wrap-content">
      <div class="number"><span>1</span></div>
      <div class="text">
        <h4>Установите криптопровайдер</h4>
        <p>
          Для создания и проверки электронных подписей по алгоритмам ГОСТ
          требуется обязательная установка криптопровайдера, поддерживающего
          ГОСТ (мы рекомендуем КриптоПро CSP).
        </p>
      </div>
    </div>
    <div class="wrap-content">
      <div class="text">
        <h4>Установите КриптоПро ЭЦП Browser plug-in</h4>
        <p>
          Приложение осуществляет взаимодействие веб-страниц в вашем браузере с
          криптопровайдером в операционной системе и предназначено для создания
          и проверки электронной подписи на веб-страницах. Рекомендуем
          воспользоваться
          <a href="https://cpdn.cryptopro.ru/default.asp?url=/content/cades/plugin-installation-windows.html" target="_blank">инструкцией по установке.</a>
        </p>
      </div>
      <div class="number"><span>2</span></div>
    </div>
    <div class="wrap-content">
      <div class="number"><span>3</span></div>
      <div class="text">
        <h4>Проверьте работу установленного плагина</h4>
        <p>
          Чтобы убедиться, что всё установлено верно и все элементы системы
          надёжно взаимодействуют, мы создали специальную площадку для
          тестирования и проверки создания электронной подписи.
        </p>
      </div>
    </div>
    <el-row :gutter="20" class="rowBtn">
      <el-col :md="12" :sm="12"
        ><el-button class="fillBlueBtn"
          ><a target="_blank" href="https://www.cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html" style="color:#fff;text-decoration: none">Проверить плагин</a></el-button
        ></el-col
      >
      <el-col :md="12" :sm="12"
        ><el-button class="fillBlueBtn"
      ><a target="_blank" href="https://cryptopro.ru/products/cades/plugin/get_2_0" style="color:#fff;text-decoration: none">Скачать КриптоПро ЭЦП Browser plug-in</a></el-button
        ></el-col
      >
    </el-row>
  </div>
</template>

<script>
export default {
  name: "index"
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wrap-content {
  display: flex;
  margin-bottom: 10px;
}
.number {
  width: 132px;
  height: 140px;
  background: #2fbfa6;
  border-radius: 10px;
  text-align: center;
  span {
    font-size: 100px;
    line-height: 117px;
  }
}
.text {
  width: calc(100% - 132px);
  padding: 0 10px;
  h4 {
    margin: 0;
  }
  a {
    color: #089fc1;
  }
}
.rowBtn {
  text-align: center;
  margin-top: 40px;
}
</style>
